<template>
  <div class="element suggest-field">
    <label v-if="label" :for="name" :class="labelClass">
      {{ label }}
      <span v-if="validate">*</span>
    </label>
    <div class="suggest-field-wrap">
      <a v-if="assigned" class="remove" href="#" @click.prevent="reset()">
        <icon icon="plus" class="icon" />
      </a>
      <input
        v-if="assigned"
        type="hidden"
        :name="name"
        :value="assigned.value"
      />
      <Field
        v-if="assigned"
        ref="placeholder"
        type="text"
        :readonly="true"
        :name="placeholderName"
        :value="assigned.label"
        input-class="form-control"
      />
      <Field
        v-if="!assigned"
        ref="search-input"
        type="text"
        :name="searchInputName"
        :placeholder="searchInputText"
        v-model="keywords"
        @blur="keywords = ''"
      />
      <ul v-if="results.length > 0" class="suggest-field-results">
        <li v-for="(item, i) in results" :key="i">
          <a href="#" @click.prevent="add(item)">{{ item.label }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String },
    labelClass: { type: String },
    name: { type: String, required: true },
    placeholderName: { type: String, default: "assigned" },
    searchInputName: { type: String, default: "keywords" },
    searchInputText: { type: String },
    searchUrl: { type: String, required: true },
    searchParams: { type: Object },
    validate: { type: String },
    value: { type: Object },
  },
  data() {
    return {
      keywords: "",
      results: [],
      assigned: null,
    };
  },
  watch: {
    value(val) {
      this.assigned = val;
    },
    keywords(val) {
      if (val.length > 0) {
        this.refresh();
      } else {
        setTimeout(() => {
          this.results = [];
        }, 300);
      }
    },
    assigned(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    refresh: _.debounce(function () {
      if (this.keywords.length === 0) return;
      var params = _.merge(
        { keywords: this.keywords },
        this.searchParams || {}
      );
      this.axios
        .get(this.searchUrl, {
          params: params,
        })
        .then((response) => {
          this.results = response.data.results;
        })
        .catch((error) => {
          this.$alert(error);
        });
    }, 300),
    add(item) {
      this.assigned = item;
      this.keywords = "";
      this.results = [];
    },
    reset() {
      this.assigned = null;
      this.keywords = "";
      this.results = [];
    },
  },
  mounted() {
    this.assigned = this.value;
  },
};
</script>
